import { Injectable, inject } from '@angular/core';
import { Subject, take } from 'rxjs';
import { Page } from 'src/app/models/page.interface';
import { environment } from 'src/environments/environment';
import { PathsService } from '../paths/paths.service';
import { ApolloPageService } from './apollo/apollo-page.service';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '../../app.config';
import {
    PAGE_NOT_FOUND_ERROR,
    APOLLO_FETCH_ERROR,
} from '../../shared/constants/error.constants';

@Injectable({
    providedIn: 'root',
})
export class PageService {
    public loading = new Subject<boolean>();
    public error: string | null = null;
    public loaded = new CustomEvent('pageloaded');
    public page: Page = new Page();
    private readonly appConfig = inject(APP_CONFIG);
    private readonly apolloPageService = inject(ApolloPageService);
    private readonly paths = inject(PathsService);
    private readonly httpClient = inject(HttpClient);

    tab(data: any, path: string): string {
        let tab = '';
        path = path.replaceAll('"', '');
        if (data) {
            if (data.parent) {
                if (data.parent.node.adsHierarchy.childPages == 'tabs') {
                    const parts = path.split('#')[0].split('/');
                    if (parts[parts.length - 1] == '') {
                        tab = parts[parts.length - 2];
                    } else {
                        tab = parts[parts.length - 1];
                    }
                }
            }
        }
        return tab;
    }

    getApolloData(version: string, path: string): void {
        this.apolloPageService
            .fetchPageByUri$(path)
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    if (!data) {
                        this.error = PAGE_NOT_FOUND_ERROR;
                        this.loading.next(false);
                        return;
                    }

                    this.error = null;
                    const tab = this.tab(data, path);
                    if (tab !== '' && data?.parent?.node) {
                        data = data.parent.node;
                    }

                    this.processData(version, data, tab);
                },
                error: (err) => {
                    this.error = APOLLO_FETCH_ERROR;
                    console.error(`Error fetching page data: ${err}`);
                    this.loading.next(false);
                },
            });
    }

    getAssetsData(version: string, path: string) {
        this.httpClient
            .get(`${this.appConfig.assetsPath}${this.appConfig.json.page}`)
            .subscribe((data: any) => {
                if (data?.pages) {
                    for (let page of data.pages) {
                        if (page.uri == path) {
                            let pageData = page;
                            const tab = this.tab(pageData, path);
                            if (tab != '') {
                                pageData = pageData.parent.node;
                            }
                            this.processData(version, pageData, tab);
                        }
                    }
                }
            });
    }

    processData(version: string, data: any, tab: string) {
        this.page = new Page(data, tab);
        this.page.content = this.paths.cleanPage(
            version,
            this.page.content,
            this.page.url,
            tab,
            true,
        );
        for (let child of this.page.children) {
            child.content = this.paths.cleanPage(
                version,
                child.content,
                this.page.url,
                child.title.toLowerCase(),
                false,
            );
        }
        this.loading.next(false);
    }

    getData(path: string): void {
        if (this.appConfig.useJson) {
            if (path == '' || path == `/${environment.base}/`) {
                path = '/';
            }
            this.getAssetsData(environment.version, path);
            return;
        }

        if (path == '' || path == `/${environment.base}/`) {
            path = '/home';
        }
        path = `aveva-design-system${path}`;
        this.getApolloData(environment.version, path);
    }

    getPageContent(path: string): void {
        this.loading.next(true);
        let url = path.split('#')[0];
        if (url) {
            url = url.replace(`${environment.base}/`, '');
            this.getData(url + '/');
        }
    }
}
